<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="projectName" id="projectName" type="text" pInputText>
            <label for="projectName">Project Name</label>
            @for (validation of validationMessages.projectName; track validation) {
              <span>
                @if (form1.get('projectName').hasError(validation.type) && (form1.get('projectName').dirty || form1.get('projectName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
            optionValue="value" placeholder="Select Status"></p-dropdown>
            <label for="Select Status">Select Status</label>
            @for (validation of validationMessages.status; track validation) {
              <span>
                @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="employees" formControlName="assignedTo" optionLabel="name"
            optionValue="value" placeholder="Assigned To"></p-dropdown>
            <label for="Assigned To">Assigned To</label>
            @for (validation of validationMessages.assignedTo; track validation) {
              <span>
                @if (form1.get('assignedTo').hasError(validation.type) && (form1.get('assignedTo').dirty || form1.get('assignedTo').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="assignedDate" inputId="assignedDate" appendTo="body">
            </p-calendar>
            <label for="assignedDate">Assigned Date</label>
            @for (validation of validationMessages.assignedDate; track validation) {
              <span>
                @if (form1.get('assignedDate').hasError(validation.type) && (form1.get('assignedDate').dirty || form1.get('assignedDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="categories" formControlName="category" optionLabel="name"
            optionValue="value" placeholder="Select Category"></p-dropdown>
            <label for="Select Category">Select Category</label>
            @for (validation of validationMessages.category; track validation) {
              <span>
                @if (form1.get('category').hasError(validation.type) && (form1.get('category').dirty || form1.get('category').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="projectDesc"><strong>Project Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <!-- <ckeditor [editor]="editor" formControlName="projectDesc" id="projectDesc" (ready)="onReady($event)"></ckeditor> -->
            <editor
              formControlName="projectDesc"
              id="projectDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.projectDesc; track validation) {
              <span>
                @if (form1.get('projectDesc').hasError(validation.type) && (form1.get('projectDesc').dirty || form1.get('projectDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      @if (codeProjectId) {
        <app-code-task-list [codeProjectId]="codeProjectId" [showFilter]="false" [showPagination]="false" [outlineNewButton]="false"></app-code-task-list>
      }
      <hr>
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
                @if (codeProjectId) {
                  <button pButton class="btn-delete p-button-outlined p-button-danger"
                  (click)="onFormDelete()">Delete CodeProject</button>
                }
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                @if (!codeProjectId) {
                  <button pButton class="btn-addt p-button" (click)="formAdd()">Add CodeProject</button>
                }

                @if (codeProjectId) {
                  <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update CodeProject</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>